<template>
  <div class="menu">
    <div
      class="menu-item"
      v-for="menu in menuObj"
      :key="menu.id"
      :index="menu.id+''"
    >
      <div
        class="single-item"
        @click="childShow(menu)"
        :id="'menu'+menu.id"
        :class="{'active':menu.id == level1Id||menu.url==$route.path||menu.id == activeId}"
      >
        <div class="icon-box"><img
            :src="'/static/'+menu.imgUrl"
            class="icon-img"
          />
        </div>
        <div class="level1-txt">{{menu.name}}</div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      currentMenu: null,
      menuList: null,
      childMenu: [],
      activeId: "",
      popoverTop: null,
      menuObj: {},
      level1Id: "",
    };
  },
  mounted() {
    document.onclick = (e) => {
      let rtnClass = [
        "single-item active",
        "icon-img",
        "level1-txt",
        "single-item",
      ];
      if (rtnClass.indexOf(e.target.className) > -1) return;
      // if (rtnClass.indexOf(e.path[0].className) > -1) return;
      this.activeId = "";
      this.$emit("hidePopover");
    };
    this.menuList = this.$utils.getUserMenu();
    this.menuList.map((item) => {
      if (item.url == this.$route.path) {
        this.level1Id = item.parentId;
        this.menuList.map((parent) => {
          if (item.parentId == parent.id) {
            this.level1Id = parent.parentId;
          }
        });
      }
    });
    this.menuObj = this.$utils.dealCascadeData(this.menuList);
  },
  methods: {
    childShow(menu) {
      if (this.activeId == menu.id) {
        this.activeId = "";
        this.$emit("hidePopover");
        return;
      }
      this.activeId = menu.id;
      if (menu.children.length == 0) {
        this.level1Id = menu.id;
        this.changePage(menu);
        this.$emit("hidePopover");
      } else {
        this.$emit("showChildren", menu);
      }
    },
    changePage(menu) {
      if (menu.url === this.$route.path) return;
      this.menuList = this.$utils.getUserMenu();
      this.menuList.map((item) => {
        if (item.url == menu.url) {
          this.level1Id = item.parentId;
          this.menuList.map((parent) => {
            if (item.parentId == parent.id) {
              this.level1Id = parent.parentId;
            }
          });
        }
      });
      this.currentMenu = menu;
      this.$utils.setCurrentMune(menu);
      this.$router.push({ path: menu.url.trim() });
      this.activeId = "";
      this.addMenuList(menu);
    },
    addMenuList(menu) {
      let menuList = this.$utils.getClickMenu();
      menuList.map((item) => {
        item.active = false;
      });
      let currentMenu = menuList.filter((item) => {
        return item.id == menu.id;
      });
      if (currentMenu.length == 0) {
        menu.active = true;
        menuList.push(menu);
      } else {
        currentMenu[0].active = true;
      }
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
  },
};
</script>
<style>
.menu {
  background: #393d49;
  height: 100%;
  width: 80px;
  /*padding-top: 10px;*/

}
.menu .title {
  display: block;
  padding: 3px 6px;
  line-height: 30px;
}
.menu .level1-txt {
  overflow: hidden;
}
.menu .icon-box {
  width: 25px;
}
.menu .icon-box .icon-img {
  width: 20px;
  height: auto;
  vertical-align: middle;
}

.menu .single-item {
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.menu .single-item.active {
  background-color: #46a0fc;
  color: #fff;
}
.menu .menu-item {
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: row;
  height: 40px;
  line-height: 40px;
  vertical-align: center;
  color: #fff;
  font-size: 12px;
  background: #393d49;
}

.menu .menu-item:hover {
  background: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/business/menu.vue